/**
 * Video Swiper Slider
 */

export function initVideoSlider() {
	const videoSwiper = document.querySelector('.video-slider');

	if (videoSwiper) {
		// eslint-disable-next-line no-undef
		new Swiper('.video-slider', {
			slidesPerView: 'auto',
			spaceBetween: 16, // gap-4
			freeMode: true,
			loop: true,
			navigation: {
				nextEl: '.video-slider-next',
				prevEl: '.video-slider-prev',
			},
			breakpoints: {
				768: {
					spaceBetween: 20, // md:gap-5
				}
			}
		});

	}
}
